import React from "react";
import styles from "./Spinner.module.scss";
const Spinner = () => (
  <div className={styles.spinner}>
    <div className={styles.spinnerInner}></div>
  </div>
);

export default Spinner;
